export default __webpack_public_path__ + "static/media/avatar-marit.bd30880e.png";